import { downloadBillingReceiptPdf } from '@/lib/billing/download-billing-receipt-pdf';

export interface BillingReceiptDownloadInput {
  invoiceId: string;
  plan: string;
  amount: string;
  currency: string;
  paymentMethod: string;
  status: string;
  startDate: string;
  endDate: string;
  autoRenew: string;
  paidAt?: string | null;
  receiptUrl?: string | null;
}

/** Downloads a billing receipt — provider URL when available, otherwise a generated PDF. */
export async function downloadBillingReceipt(
  item: BillingReceiptDownloadInput
): Promise<boolean> {
  const url = item.receiptUrl?.trim();
  if (url) {
    const anchor = document.createElement('a');
    anchor.href = url;
    anchor.target = '_blank';
    anchor.rel = 'noopener noreferrer';
    anchor.download = `receipt-${item.invoiceId}.pdf`;
    document.body.appendChild(anchor);
    anchor.click();
    document.body.removeChild(anchor);
    return true;
  }

  await downloadBillingReceiptPdf({
    invoiceId: item.invoiceId,
    plan: item.plan,
    amount: item.amount,
    currency: item.currency,
    paymentMethod: item.paymentMethod,
    status: item.status,
    startDate: item.startDate,
    endDate: item.endDate,
    autoRenew: item.autoRenew,
    paidAt: item.paidAt,
  });

  return true;
}
